var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3559 9.10149C12.4253 9.17036 12.4723 9.25782 12.491 9.35286C12.5097 9.44786 12.4992 9.54618 12.4609 9.63536C12.4234 9.7248 12.3597 9.80139 12.2778 9.85542C12.1959 9.90945 12.0996 9.93858 12.0009 9.93904H2.5001V1.12273H12.0009C12.0996 1.12319 12.1959 1.15232 12.2778 1.20635C12.3597 1.26038 12.4234 1.33696 12.4609 1.4264C12.4992 1.51559 12.5097 1.6139 12.491 1.7089C12.4723 1.80395 12.4253 1.89141 12.3559 1.96028L8.7056 5.53095L12.3559 9.10149ZM1.00004 0.143066C0.867426 0.143066 0.740233 0.194648 0.646465 0.286531C0.552655 0.378367 0.5 0.502955 0.5 0.632862V13.3675C0.5 13.5425 0.59532 13.7042 0.75002 13.7917C0.904726 13.8792 1.09536 13.8792 1.25006 13.7917C1.40477 13.7042 1.50008 13.5425 1.50008 13.3675V0.632862C1.50008 0.502964 1.44742 0.378377 1.35362 0.286531C1.25986 0.194643 1.13266 0.143066 1.00004 0.143066Z",
    fill: "#A30001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFlag);
export default __webpack_public_path__ + "static/media/ActiveFlag.42bc20144e35f606a44af434e72f83f7.svg";
export { ForwardRef as ReactComponent };